export default class MetaProperties {
    public nextPageStartsAfter: string = null;
    public itemsPerPage: number = null;
}